import {css, html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import {ifDefined} from 'lit/directives/if-defined.js';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';

@customElement('webs-resource')
export class Resource extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
    .m-resource .card {
      margin-bottom: 1.5rem;
    }

    ::slotted(webs-button) {
      display: inline-block;
      margin: .2rem .5rem 0 0;
    }

    ::slotted(webs-button:last-of-type) {
      margin-right: 0;
    }
    `
  ]

  @property()
  id: string;

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 767px)');

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @state()
  private isDesktop: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.smallDevice.addEventListener('change', (e) => this.handleDeviceChange(e));
  }

  protected render(): unknown {
    this.handleDeviceChange(this.smallDevice);
    return this.isDesktop ? this.resourceDesktop : this.resourceMobile;
  }

  get resourceDesktop(): unknown {
    return html`
    <section id="${ifDefined(this.id)}" class="m-resource ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
    <div part="container" class="container">
      <webs-grid-row>
        <webs-grid-column col="12" sm="5" md="4">
          <slot name="card"></slot>
        </webs-grid-column>
        <webs-grid-column col="12" sm="7" md-offset="1">
        <div>
          <slot name="title"></slot>
          <slot></slot>
          <slot name="button"></slot>
        </div>
        </webs-grid-column>
        </div>
      </webs-grid-row>
      </section>`
    }

    get resourceMobile(): unknown {
      return html`
      <section id="${ifDefined(this.id)}" class="m-resource ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
      <div part="container" class="container">
        <webs-grid-row>

          <webs-grid-column col="12" md="7" md-offset="1">
          <div>
            <slot name="title"></slot>
            <slot></slot>
            <div class="card">
              <slot name="card"></slot>
            </div>

            <slot name="button"></slot>
          </div>
          </webs-grid-column>
          </div>
        </webs-grid-row>
        </section>`
      }
      private handleDeviceChange(event): void {
        this.isDesktop = event.matches;
        this.requestUpdate();
      }
  }

